import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, LICENSE, NAV_LINKS, INSTAGRAM_URL, FACEBOOK_URL, scrollToSection } from "./data";

const SERVICE_LIST = [
  "Interior Painting",
  "Exterior Painting",
  "Commercial Painting",
  "Residential Painting",
  "Cabinet Refinishing",
  "Fence & Deck Staining",
];

const Footer = () => (
  <footer data-testid="footer" className="bg-navy-dark pb-28 pt-16 text-white md:pb-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <span className="inline-block rounded-xl bg-white p-3 shadow-md" data-testid="footer-logo">
            <img src="/assets/logo.png" alt="Teo's Painting LLC logo" className="h-16 w-auto" />
          </span>
          <p className="mt-5 font-display text-lg italic text-gold">"Professional Painting. Beautiful Results."</p>
          <p className="mt-3 flex items-center gap-2 text-sm text-white/60">
            <MapPin size={14} className="text-gold" /> Reno • Sparks • Carson City
          </p>
          <p className="mt-2 font-mono text-[10px] tracking-[0.2em] text-white/40">{LICENSE.toUpperCase()}</p>
          <div className="mt-5 flex gap-3">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" aria-label="Teo's Painting on Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors hover:border-gold hover:text-gold">
              <Instagram size={17} />
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" data-testid="footer-facebook-link" aria-label="Teo's Painting on Facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors hover:border-gold hover:text-gold">
              <Facebook size={17} />
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-mono text-[11px] tracking-[0.28em] text-gold">CONTACT</h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a href={PHONE_HREF} data-testid="footer-phone-link" className="flex items-center gap-2.5 text-white/75 transition-colors hover:text-gold">
                <Phone size={14} className="text-gold" /> {PHONE}
              </a>
            </li>
            <li>
              <a href={EMAIL_HREF} data-testid="footer-email-link" className="flex items-center gap-2.5 break-all text-white/75 transition-colors hover:text-gold">
                <Mail size={14} className="shrink-0 text-gold" /> {EMAIL}
              </a>
            </li>
          </ul>
          <h3 className="mt-8 font-mono text-[11px] tracking-[0.28em] text-gold">EXPLORE</h3>
          <ul className="mt-5 space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(l.href);
                  }}
                  className="text-white/60 transition-colors hover:text-gold"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] tracking-[0.28em] text-gold">SERVICES</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-white/60">
            {SERVICE_LIST.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-[11px] tracking-[0.28em] text-gold">FREE ESTIMATE</h3>
          <p className="mt-5 text-sm leading-relaxed text-white/60">
            Interior, exterior, cabinets, fences and decks — every project starts with a free, friendly estimate.
          </p>
          <button
            data-testid="footer-estimate-cta"
            onClick={() => scrollToSection("#contact")}
            className="mt-5 rounded-full bg-gold px-6 py-3 text-[12px] font-extrabold tracking-[0.14em] text-navy transition-[background-color,transform] duration-200 hover:scale-[1.04] hover:bg-gold-light"
          >
            GET A FREE ESTIMATE
          </button>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center gap-3 border-t border-white/10 pt-7 text-center">
        <p className="text-xs text-white/45">© 2026 Teo's Painting LLC. All rights reserved.</p>
        <p className="max-w-3xl text-[11px] leading-relaxed text-white/30">
          Painting company in Reno NV — house painters Reno, interior &amp; exterior painting, cabinet refinishing,
          fence staining &amp; deck staining in Reno, Sparks &amp; Carson City, Nevada.
        </p>
        <a href="/admin" data-testid="footer-admin-link" className="text-[11px] text-white/25 transition-colors hover:text-gold">
          Owner Login
        </a>
      </div>
    </div>
  </footer>
);

export const MobileCTABar = () => (
  <div data-testid="mobile-cta-bar" className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 md:hidden">
    <a
      href={PHONE_HREF}
      data-testid="mobile-bar-call"
      className="flex items-center justify-center gap-2 bg-navy py-4 text-[12px] font-extrabold tracking-[0.14em] text-white"
    >
      <Phone size={15} className="text-gold" /> CALL NOW
    </a>
    <button
      data-testid="mobile-bar-estimate"
      onClick={() => scrollToSection("#contact")}
      className="bg-gold py-4 text-[12px] font-extrabold tracking-[0.14em] text-navy"
    >
      FREE ESTIMATE
    </button>
  </div>
);

export default Footer;
